export const NOTIFICATION_BANNER_QUERY_KEY = "notification-banner"
export const QUERY_CACHE_TIME = 30 * 60 * 1_000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1_000 // 15 min
